<template>
  <div class="container-chart">
    <div class="container-fluid">
      <div class="chart-disclosure" id="chart-disclosure">
        <div class="header">
          <div class="title" v-on:click="findHistory()">{{translation.disclosure_title}}</div>
          <div class="options">
            <div
              class="item"
              v-bind:class="{active: period == 'day'}"
              v-on:click="findHistory('day')"
            >{{translation.today}}</div>
            <div
              class="item"
              v-bind:class="{active: period == 'month'}"
              v-on:click="findHistory('month')"
            >{{translation.month}}</div>
            <div
              class="item"
              v-bind:class="{active: period == 'year'}"
              v-on:click="findHistory('year')"
            >{{translation.year}}</div>
          </div>
        </div>
        <div class="container">
          <div class="content left">
            <div class="values">
              <div class="lbl" v-for="(i, index) in labels" v-text="i" :key="index"></div>
            </div>
            <div class="view" v-on:mouseLeave="show(resume)">
              <div class="bar" v-for="(b, indexB) in bars" v-on:mouseover="show(b)" :key="indexB">
                <div
                  class="value"
                  v-bind:class="{active: b.total > 0}"
                  v-bind:style="{ height: b.bar }"
                ></div>
                <div class="lbl" v-text="b.label"></div>
              </div>
            </div>
            <div class="pie">
              <div class="bar access" v-bind:style="{height: current.pie.access}"></div>
              <div class="bar register" v-bind:style="{height: current.pie.conversions}"></div>
            </div>
          </div>
          <div class="content right">
            <div class="line header">
              <div class="item url">{{translation.label_url}}</div>
              <div class="item access">{{translation.access}}</div>
              <div class="item register">{{translation.registration}}</div>
            </div>
            <div class="lines" v-if="current.data.length">
              <div class="line" v-for="(l, indexL) in current.data" :key="indexL">
                <div class="item url" v-bind:title="l.url" v-text="l.url"></div>
                <div class="item access" v-text="l.access"></div>
                <div class="item register" v-text="l.conversions"></div>
              </div>
            </div>
            <div class="empty" v-if="!current.data.length">{{translation.disclosure_empty}}</div>
          </div>
        </div>
        <div class="loading" v-if="loading"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as ramda from '//cdnjs.cloudflare.com/ajax/libs/ramda/0.25.0/ramda.min.js';
const BASE_URI = window.location.pathname;
const LANGS = { us: "en", br: "pt" };

export default {
  name: "graphic-disclosures",
  data() {
    return {
      bars: [],
      labels: [],
      current: { data: [], pie: {} },
      resume: { data: [], pie: {} },
      period: "day",
      loading: false,
      translation: this.$parent.$parent.view.translation.graphicDisclosures
    };
  },
  methods: {
    findHistory(period = this.period) {
      this.loading = true;
      this.period = period;
      axios
        .get(`${BASE_URI}/disclosure/history/${period}`)
        .then(res => {
          let data = R.map(
            v => ({
              ...v,
              url: v.url.replace(/https?\:\/\//, ""),
              total: Number(v.total),
              access: Number(v.access),
              conversions: Number(v.conversions)
            }),
            res.data
          );

          let history = R.groupBy(h => h.label, this.sortHistory(data));

          let bars = this.makeBars(period, history);

          let max = R.reduce(
            (c, { total }) => (total > c ? total : c),
            0,
            bars
          );
          if (max < 10) {
            max = 10;
          }

          let barsWithPercent = R.map(
            b => ({
              bar: `calc(calc(100% - 20px) * ${max && b.total / max})`,
              pie: {
                access: `${b.total && (b.access / b.total) * 100}%`,
                conversions: `${b.total && (b.conversions / b.total) * 100}%`
              },
              ...b
            }),
            bars
          );

          let tick = 5;
          let unit = max / tick;
          let labels = [];
          for (let i = 0; i <= tick; i++) {
            labels.unshift(Math.floor(i * unit));
          }

          let urls = this.sortHistory(
            R.map(
              s =>
                R.reduce(
                  (c, v) => ({
                    url: v.url,
                    total: c.total + v.total,
                    access: c.access + v.access,
                    conversions: c.conversions + v.conversions
                  }),
                  { total: 0, access: 0, conversions: 0 },
                  s
                ),
              R.groupBy(a => a.url, data)
            )
          );

          let total = R.reduce(
            (c, v) => ({
              total: c.total + v.total,
              access: c.access + v.access,
              conversions: c.conversions + v.conversions
            }),
            { total: 0, access: 0, conversions: 0 },
            urls
          );

          let resume = {
            data: urls,
            pie: {
              access: `${total.total && (total.access / total.total) * 100}%`,
              conversions: `${total.total &&
                (total.conversions / total.total) * 100}%`
            }
          };

          this.bars = barsWithPercent;
          this.labels = labels;
          this.resume = resume;
          this.show();
        })
        .finally(() => (this.loading = false));
    },
    sortHistory(list) {
      return R.sort((a, b) => {
        if (a.conversions > b.conversions) return -1;
        if (a.conversions < b.conversions) return 1;
        if (a.access > b.access) return -1;
        if (a.access < b.access) return 1;
        return 0;
      }, R.values(list));
    },
    makeBars(period, data) {
      let count,
        name,
        format,
        find,
        fix = 0;
      switch (period) {
        case "day":
          count = 24;
          name = "hour";
          format = "HH";
          find = "DD-HH";
          fix = -1;
          break;

        case "month":
          count = 30;
          name = "day";
          format = "DD";
          find = "MM-DD";
          fix = -1;
          break;

        default:
          count = 12;
          name = "month";
          format = "MMM";
          find = "YYYY-MM";
          fix = -1;
          break;
      }
      return Array.apply(null, Array(count)).map((v, i) => {
        const month = count - i;
        let label = moment().subtract(month + fix, name);
        let h = data[label.format(find)] || [];
        let value = h.reduce(
          (c, v) => ({
            total: c.total + v.total,
            access: c.access + v.access,
            conversions: c.conversions + v.conversions
          }),
          { total: 0, access: 0, conversions: 0 }
        );
        return {
          label: label.format(format),
          ...value,
          data: h
        };
      });
    },
    show(v = this.resume) {
      this.current = v;
    }
  },
  mounted() {
    let locale = window.__env.locale;
    moment.locale(LANGS[locale] || locale);
    this.findHistory();
    const plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      "//cdnjs.cloudflare.com/ajax/libs/ramda/0.25.0/ramda.min.js"
    );
    plugin.async = true;
    document.head.appendChild(plugin);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.container-chart{
  padding-right: 10px;
  padding-left: 10px;
}
.chart-disclosure {
  $primary: #1e90ff;
  $access: #ffa502;
  $register: #2ed573;

  display: flex;
  flex: 1;
  border-radius: 6px;
  box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.03);
  overflow: hidden;
  background: #fff;
  flex-direction: column;
  padding: 20px;
  position: relative;

  * {
    font-family: Muli-Regular;
    max-width: 100%;
    color: #556666;
  }

  .header {
    display: flex;
    margin-bottom: 20px;
    align-items: center;

    .title {
      font-size: 1.1rem;
      text-align: center;
      display: flex;
      align-items: center;
      font-family: Muli-Regular;
      flex: 1;

      &:before {
        content: "";
        display: block;
        background-image: url(/internacional/public/images/icons/megaphone.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        height: 32px;
        width: 32px;
        margin-right: 20px;
        opacity: 0.75;
      }
    }

    .options {
      display: flex;

      .item {
        transition: color 300ms;
        margin-left: 20px;
        font-size: 12px;
        cursor: pointer;

        &:hover {
          color: $primary;
        }

        &.active {
          font-weight: bold;
        }
      }
    }
  }

  .container {
    display: flex;
    flex: 1;
    padding: 0;
    margin: 0;
    width: 100%;

    .content {
      display: flex;
      flex-direction: column;

      &.left {
        min-height: 200px;
        display: flex;
        width: 60%;
        flex-direction: row;
        padding: 0;

        .values {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 20px;

          .lbl {
            font-size: 8px;
            letter-spacing: 1px;
            font-family: Muli-Bold;
            border-bottom: 1px solid transparent;
            height: 10px;
            line-height: 10px;
          }
        }

        .view {
          display: flex;
          flex: 1;
          justify-content: space-between;
          align-items: flex-end;
          padding-right: 20px;

          .bar {
            display: flex;
            flex-direction: column;
            flex: 1;
            align-items: center;
            height: 100%;
            justify-content: flex-end;
            cursor: pointer;

            .lbl {
              transition: color, border 300ms;
              margin-top: 10px;
              font-size: 8px;
              letter-spacing: 1px;
              font-family: Muli-Bold;
              height: 10px;
              line-height: 10px;
              text-transform: uppercase;
            }

            .value {
              transition: height 500ms, background-color 250ms;
              width: 6px;
              border-radius: 6px;
              min-height: 2px;
              background-color: #eee;

              &.active {
                background-color: $primary;
              }
            }

            &:hover {
              .lbl {
                color: $primary;
              }
            }
          }
        }

        .pie {
          width: 6px;
          border-radius: 6px;
          background-color: #eee;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .bar {
            transition: height 500ms;
            height: 0%;

            &.access {
              background: $access;
            }

            &.register {
              background: $register;
            }
          }
        }
      }

      &.right {
        padding-left: 20px;
        width: 40%;

        .line {
          display: flex;
          margin: 10px 0;
          min-height: min-content;

          .item {
            width: 100px;
            text-align: center;
            font-size: 13px;

            &.url {
              flex: 1;
              text-align: left;
              overflow-x: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            &.access {
              color: $access;
            }

            &.register {
              color: $register;
            }
          }

          &.header {
            margin-top: 0;
            border-bottom: 1px solid #eee;
            padding-bottom: 5px;

            .item {
              font-family: Muli-Bold;
            }
          }
        }

        .lines {
          display: flex;
          flex-direction: column;
          overflow-y: auto;
          height: 200px;

          &::-webkit-scrollbar {
            width: 5px;
          }

          &::-webkit-scrollbar-track {
            background: #fff;
          }

          &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 5px;
          }

          &::-webkit-scrollbar-thumb:hover {
            background: #ccc;
          }
        }

        .empty {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.8rem;
          color: #ccc;
          height: 200px;
        }
      }
    }
  }

  .loading {
    background-color: rgba(255, 255, 255, 0.75);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(/internacional/public/images/loading-bar-blue.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 128px;
  }

  @media screen and (max-width: 1200px) {
    .container {
      flex-direction: column;

      .content {
        padding: 0;

        &.left {
          width: 100%;

          .view {
            .value {
              width: 3px !important;
            }
          }

          .pie {
            width: 3px !important;
          }

          .lbl {
            font-size: 5px !important;
          }
        }

        &.right {
          width: 100%;
          min-height: 40%;
          margin-top: 32px;
        }
      }
    }
  }
}

.flat .chart-disclosure {
  box-shadow: none;
  padding: 20px 10px;
  border-radius: 0px;
  * {
    border-radius: 0px !important;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/graphicDisclosures.vue